export const TYPES = {
  PAY: "PAY",
  DISTRIBUTION: "DISTRIBUTION",
  NOCOUNT: "NOCOUNT",
  BUYBACK: "BUYBACK",
};

export const HISTORY_PAYMENT_TYPES = [
  { value: "ALL", label: "ALL" },
  { value: "PAY", label: "PAY" },
  { value: "DISTRIBUTION", label: "DISTRIBUTION" },
  { value: "NOCOUNT", label: "NO COUNT" },
  { value: "BUYBACK", label: "BUY BACK" },
];

export const HISTORY_TABLE_COLUMNS = [
  { name: "Name", label: "Tên Người Dùng" },
  { name: "Knb", label: "Knb Được Thêm" },
  { name: "KnbKhoa", label: "Knb Khóa Được Thêm" },
  { name: "VoucherCode", label: "Mã khuyến mãi" },
  { name: "ReferenceAmount", label: "5% KNB khóa từ" },
  { name: "UserCreate", label: "Người Thêm" },
  { name: "Type", label: "Loại Thêm" },
  { name: "CreatedDate", label: "Ngày Thêm" },
  { name: "MisaInvoiceStatus", label: "Trạng thái hóa đơn" },
  { name: "InvoiceAction", label: "" },
];
